import { HttpService } from '@/infra/http'
import type { TGetSimulacaoDuplicarResponse } from '@/types/simulacao'

export class GetSimulacaoDuplicarService extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoDuplicarResponse>(`/api/v2/Simulacao/${simulacaoId}/duplicar`)
  }
}
